<template>
  <v-container fluid>
    <retail
      :StoreInfo="UserInfo"
      BranchColor="error"
      :headers="headers"
      :products="products"
    ></retail>
  </v-container>
</template>
<script>
import { tokenMixin } from "@/Mixins/tokenMixins.js";
import { mapGetters } from "vuex";
export default {
  components: {
    retail: () => import("@/components/Branches/Sales/retail"),
  },

  mixins: [tokenMixin],
  data() {
    return {
      urlProduct: "/products",
      products: [],
      headers: [
        // {
        //   text: "Order",
        //   align: "left",
        //   value: "code",
        //   class: "grey darken-3 white--text",
        // },
        {
          text: "Product",
          align: "left",
          value: "AccountName",
          class: "grey darken-3 white--text",
        },
        {
          text: "Item",
          align: "left",
          value: "InvName",
          class: "grey darken-3 white--text",
        },
        {
          text: "QTY",
          value: "qty",
          class: "grey darken-3 white--text",
        },
        // {
        //   text: "Unit QTY",
        //   value: "UnitQty",
        //   class: "grey darken-3 white--text"
        // },
        {
          text: "Item Price",
          value: "price",
          class: "grey darken-3 white--text",
        },
        {
          text: "Cart",
          value: "cart",
          align: "start",
          class: "grey darken-3 white--text",
        },
      ],
    };
  },

  computed: {
    ...mapGetters(["getProducts"]),
  },

  methods: {
    loadProducts() {
      this.$store
        .dispatch("GET_ONLY", this.urlProduct)
        .then(result => {
          // console.log(result);
          this.products = result.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
  },

  created() {
    // this.loadProducts();
    if (!this.getProducts.length) this.$store.dispatch("LoadProdacts");
  },
};
</script>
